<template>
  <div :class="$style.charity">
    <h2 id="js-charity-title" :class="$style.title">
      <span class="app-fadeInUp">社会公益</span>
    </h2>
    <div id="js-charity-part1" :class="$style.part_1">
      <div :class="['app-fadeInUp', $style.part_wrap]">
        <img v-lazy="data[0] && data[0].thumb" />
        <the-charity-content :data="data[0]" :class="$style.content" />
      </div>
    </div>
    <div id="js-charity-part2" :class="$style.part_2">
      <div :class="['app-fadeInUp', $style.part_wrap]">
        <the-charity-content :data="data[1]" :class="$style.content" />
        <img v-lazy="data[1] && data[1].thumb" />
      </div>
    </div>
  </div>
</template>

<script>
import fadeMixins from '@/assets/js/fadeMixins'
import TheCharityContent from './TheCharityContent'

export default {
  components: { TheCharityContent },
  mixins: [fadeMixins],
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      name: 'charity',
      animateScenesData: ['title', 'part1', 'part2'],
    }
  },
}
</script>

<style lang="less" module>
@content-width: 3.6rem;
@img-border-radius: 0.2rem;

// 装饰数字
@num-width: 0.99rem;
@num-height: 0.73rem;

.charity {
  position: relative;
  padding-top: @padding-base-title;
  padding-bottom: @padding-base;

  // 装饰色块
  &::before {
    .size(9.57rem, 10.85rem);
    content: '';
    position: absolute;
    top: 4.13rem;
    right: 0;
    background-color: #fbfbfb;
  }
}

.title {
  span {
    .subtitle-size(6.77rem, 0.9rem);
    .text-hide();
    display: block;
    margin-left: 3.09rem;
    background: url('./images/charity-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.part {
  &_wrap {
    display: flex;
  }

  &_1,
  &_2 {
    .content {
      position: relative;
      width: @content-width;

      // 装饰数字
      &::before {
        .size(@num-width, @num-height);
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        background: url('./images/charity-badge.png') no-repeat;
        background-size: 200% 100%;
      }
    }
  }

  &_1 {
    margin-top: 0.81rem;
    padding-bottom: 1.15rem;

    img {
      .size(11.8rem, 5.87rem);
      border-radius: 0 @img-border-radius @img-border-radius 0;
    }

    .content {
      margin-left: 0.7rem;

      &::before {
        background-position: 0 0;
      }
    }
  }

  &_2 {
    img {
      .size(8.7rem, 5.25rem);
      margin-left: 0.7rem;
      border-radius: @img-border-radius;
    }

    .content {
      margin-left: 3.09rem;

      &::before {
        background-position: 100% 0;
      }
    }
  }
}

@media screen and (max-width: @tablet-width) {
  @margin-tablet: 1.1rem;

  .charity {
    // 装饰色块
    &::before {
      top: 4.58rem;
    }
  }

  .title {
    span {
      margin-left: @margin-tablet;
    }
  }

  .part {
    &_1 {
      .content {
        width: @content-width + 2;
      }
    }

    &_2 {
      .content {
        width: @content-width + 4;
        margin-left: @margin-tablet;
      }
    }
  }
}

@media screen and (max-width: @mini-width) {
  @padding-mini: 0.8rem;

  .charity {
    &::before {
      content: none;
    }
  }

  .title {
    span {
      margin-left: @padding-mini;
    }
  }

  .part {
    &_1,
    &_2 {
      margin-left: @padding-mini;
      margin-right: @padding-mini;

      img {
        .size(100%, auto);
        margin-left: 0;
      }

      .content {
        width: auto;
        margin-top: 1em;
        margin-left: 0;

        // 装饰数字
        &::before {
          .size(@num-width * @life-charity-mini, @num-height * @life-charity-mini);
        }
      }
    }

    &_1 {
      .part_wrap {
        flex-direction: column;
      }

      img {
        border-radius: @img-border-radius;
      }
    }

    &_2 {
      .part_wrap {
        flex-direction: column-reverse;
      }
    }
  }
}
</style>
